/**
 * @generated SignedSource<<767f3b0cc8b739bfba48ec2fad6fc7bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type nav_NotificationCenterButton_viewer_refetchUnreadCount$variables = {};
export type nav_NotificationCenterButton_viewer_refetchUnreadCount$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"nav_NotificationCenterButton_viewer">;
  };
};
export type nav_NotificationCenterButton_viewer_refetchUnreadCount = {
  response: nav_NotificationCenterButton_viewer_refetchUnreadCount$data;
  variables: nav_NotificationCenterButton_viewer_refetchUnreadCount$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "nav_NotificationCenterButton_viewer_refetchUnreadCount",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "nav_NotificationCenterButton_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "nav_NotificationCenterButton_viewer_refetchUnreadCount",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationCenter",
            "kind": "LinkedField",
            "name": "notificationCenter",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unreadNotificationCount",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1c48c99a4d13d53066a3fb8379f00f68",
    "id": null,
    "metadata": {},
    "name": "nav_NotificationCenterButton_viewer_refetchUnreadCount",
    "operationKind": "query",
    "text": "query nav_NotificationCenterButton_viewer_refetchUnreadCount {\n  viewer {\n    ...nav_NotificationCenterButton_viewer\n    id\n  }\n}\n\nfragment nav_NotificationCenterButton_viewer on Viewer {\n  notificationCenter {\n    id\n    unreadNotificationCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "60606ad3e188e6605612abf43848bc94";

export default node;
